import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/src/components/footer/footer.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/src/components/header/header.comp.tsx");
